module.exports = __webpack_public_path__ + "img/pentagon.0930d29f.png";